import { baseApi } from './baseApi';

export const retentionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRetentionStats: builder.query({
      query: () => '/retention/stats',
      providesTags: ['RetentionStats'],
    }),

    getRetentionUsers: builder.query({
      query: (params) => ({
        url: '/retention/users',
        params,
      }),
      providesTags: ['RetentionUsers'],
    }),

    getRetentionUser: builder.query({
      query: (id) => `/retention/users/${id}`,
    }),

    getCampaignStats: builder.query({
      query: () => '/retention/campaigns',
      providesTags: ['CampaignStats'],
    }),

    getChurnTrend: builder.query({
      query: (days = 30) => ({
        url: '/retention/churn-trend',
        params: { days },
      }),
    }),

    getRiskTransitionStats: builder.query({
      query: () => '/retention/risk-transitions',
      providesTags: ['RetentionStats'],
    }),

    getEngagementStats: builder.query({
      query: () => '/retention/engagement',
      providesTags: ['RetentionStats'],
    }),

    getCohortBreakdowns: builder.query({
      query: () => '/retention/cohort-breakdowns',
      providesTags: ['RetentionStats'],
    }),
  }),
});

export const {
  useGetRetentionStatsQuery,
  useGetRetentionUsersQuery,
  useGetRetentionUserQuery,
  useGetCampaignStatsQuery,
  useGetChurnTrendQuery,
  useGetRiskTransitionStatsQuery,
  useGetEngagementStatsQuery,
  useGetCohortBreakdownsQuery,
} = retentionApi;
